import React, { useState } from 'react';
import './HomeVideo.scss';
import homeVideo from '../../Assets/Videos/home-video.mp4';
import { GoUnmute, GoMute } from 'react-icons/go';
import Images from '../../Assets/Images/Images';

const HomeVideo = () => {
  const [mute, setMute] = useState(true);

  return (
    <div className='home-video-wrapper'>
      <video className='home-video' autoPlay playsInline loop muted={mute} id='homeVideo'>
        <source src={homeVideo} type='video/mp4' />
        Your browser does not support HTML5 video.
      </video>
      <div
        className='home-video__image'
        style={{ backgroundImage: `url(${Images.homeSlideOne}` }}
      >
        <h2 className='home-video__title'>Kost khusus putri nyaman dan aman</h2>
        <button className='mute-btn' onClick={() => setMute(!mute)}>
          {mute ? <GoMute /> : <GoUnmute />}
        </button>
      </div>
    </div>
  )
};

export default HomeVideo;
